import { render, staticRenderFns } from "./Airfield.vue?vue&type=template&id=01c720f8"
import script from "./Airfield.vue?vue&type=script&lang=js"
export * from "./Airfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports